export const displayFlex = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

export const displayFlexColumn = {
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'center'
}

export const displayFlexEnd = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'

}
export const displayFlexColumnEnd = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end'
}

export const displaySpaceAround = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center'
}

export const displaySpaceBetween = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

export const displaySpaceBetweenColumn = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // alignItems: 'center'
}

export const weblysleekFontStyle = {
    fontFamily: "weblysleekuil",
    color: "#000000",
};

export const weblysleekBoltFontStyle = {
    fontFamily: "weblysleekuisb",
    color: "#000000",
};

export const hudsonNYFontStyle = {
    fontFamily: "HudsonNYSerif",
    color: "#000000",
};